/* =================================================================
   whatsapp-cta.js
   Pairs with whatsapp-cta.liquid + whatsapp-cta.css.

   Uses event delegation on document, and an init guard, so this
   works correctly no matter how many times the "whatsapp-cta" snippet
   is rendered on the same page (footer + PDP + floating button, etc):
   one shared QR modal, built lazily on first desktop click, reused
   by every .wa-cta-btn on the page.

   Mobile (<=750px) — button behaves as a normal link, opens the
   WhatsApp app / wa.me flow directly.
   Desktop (>750px) — click is intercepted, opens a QR popup instead
   so people can scan and continue on their phone.
   ================================================================= */

(function () {
  if (window.__waCtaInit) return;
  window.__waCtaInit = true;

  function isDesktopViewport() {
    return window.innerWidth > 750;
  }

  let modalOverlay, modalClose, qrImg;

  function buildModal() {
    if (modalOverlay) return;

    const wrap = document.createElement("div");
    wrap.innerHTML = `
      <div class="wa-cta-modal-overlay" id="waCtaModalOverlay" aria-hidden="true">
        <div class="wa-cta-modal" role="dialog" aria-modal="true" aria-label="סרקו כדי לדבר איתנו בוואטסאפ">
          <button type="button" class="wa-cta-modal-close" id="waCtaModalClose" aria-label="סגור">✕</button>
          <h3 class="wa-cta-modal-title">סרקו כדי לדבר איתנו</h3>
          <div class="wa-cta-qr-wrap">
            <img src="" alt="קוד QR לפתיחת שיחה בוואטסאפ" id="waCtaQrImg" width="200" height="200" loading="lazy" />
          </div>
          <p class="wa-cta-modal-text">פתחו את המצלמה בטלפון וסרקו את הקוד כדי לדבר איתנו ישירות בוואטסאפ.</p>
        </div>
      </div>`;
    document.body.appendChild(wrap.firstElementChild);

    modalOverlay = document.getElementById("waCtaModalOverlay");
    modalClose   = document.getElementById("waCtaModalClose");
    qrImg        = document.getElementById("waCtaQrImg");

    modalClose.addEventListener("click", closeModal);
    modalOverlay.addEventListener("click", (e) => { if (e.target === modalOverlay) closeModal(); });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modalOverlay.classList.contains("is-open")) closeModal();
    });
  }

  function openModal(waUrl) {
    buildModal();
    qrImg.src = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(waUrl)}`;

    const scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top      = `-${scrollY}px`;
    document.body.style.width    = "100%";
    modalOverlay.classList.add("is-open");
    modalOverlay.setAttribute("aria-hidden", "false");
    modalClose.focus();
  }

  function closeModal() {
    if (!modalOverlay) return;
    const scrollY = Math.abs(parseInt(document.body.style.top || "0"));
    document.body.style.position = "";
    document.body.style.top      = "";
    document.body.style.width    = "";
    window.scrollTo(0, scrollY);
    modalOverlay.classList.remove("is-open");
    modalOverlay.setAttribute("aria-hidden", "true");
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-wa-cta]");
    if (!btn || !isDesktopViewport()) return;
    e.preventDefault();
    openModal(btn.href);
  });
})();
